var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-ui-speechbubble",class:{
	'state-is-active': _vm.isActive,
}},[_c('ViewSprite',{ref:"sprite",attrs:{"frameRate":24,"frameMax":63,"frameMin":48}}),_c('p',{staticClass:"caption"},[_vm._v(" "+_vm._s(_vm.phrases[_vm.phraseIndex])+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }